export enum PrintResult {
    SUCCESS = 'SUCCESS',
    QUEUED = 'QUEUED',
    ERROR = 'ERROR',
}

export enum ConnectionStatus {
    CONNECTED = 'CONNECTED',
    IS_CONNECTING = 'IS_CONNECTING',
    DISCONNECTED = 'DISCONNECTED',
    ERROR = 'ERROR'
}

export enum PaperSize {
    SIZE_80MM = 80,
    SIZE_58MM = 58
}